import AScene from "../../library/ExtendedObjects/AScene.js";
import Backgrounds from "../Backgrounds.js";
import gameData from "../../gameData.js";
import BonusTimer from "./BonusTimer.js";
import BonusBanner from "./BonusBanner.js";
import GameMenu from "../GameMenu.js";

export default class Bonus extends AScene
{
    create()
    {
        this.background = new Backgrounds(this);
        this.background.displayBG(gameData.backgroundClasses[gameData.curBackground], false);
        this.background.displayBG(gameData.backgroundClasses.moneyBG, true);
        this.background.setDepth(-1);

        this.pig = this.addSpine(-510, 650, "Pig", "GoldPig", true);
        this.pig.spine.setScale(1.5);
        this.pig.addDropShadow(20, 20);
        this.pig.setMixByName("GoldPig", "GoldPig_Jump", .1);
        this.pig.setMixByName("GoldPig_Idle", "GoldPig_Jump", .1);

        this.title = this.addImage(this.mid.x + 20, this.mid.y - 135, "BonusGame").setDepth(2).setAlpha(0);
        this.description = this.addText(this.mid.x + 20, this.mid.y, 38, 0xa86f08, gameData.fonts.comfortaa_bold, "The piggy bank is hungry for coins!\nCatch as much money as you can\nbefore the timer runs out!", null, true);
        this.description.setDepth(2).setAlpha(0);
        this.playButton = this.addButton(this.mid.x, 675, "Title_PlyBtn", ()=>{
            this.addTween(this.titleJingle, 500, {volume: 0});
            this.playSound("bonus_jingle");
            this.startGame();
        }).setAlpha(0).setScale(2);

        this.pigMoveSpeed = .6;
        this.coinFallSpeed = .4;
        this.coinSpawnFrequency = 500;
        this.coinChances = {
            quarter: .1,
            dime: .2,
            nickel: .3
        };
        this.pigCatchThreshold_Width = 130;
        this.pigCatchThreshold_Height = 200;

        this.isJumping = false;
        this.isStarted = false;
        this.coinsCollected = [];
        this.coins = [];
        this.moneyCollected = 0;

        this.bonusTimer = new BonusTimer(this, 950, 187).setDepth(3).setScale(0);
        this.banner = new BonusBanner(this, this.mid.x, -65).setDepth(3);

        this.titleJingle = this.playSound("title_jingle");

        this.addTween(this.pig.spine, 2800, { x: this.mid.x - 20 }, Phaser.Math.Linear.Linear, () => {
            this.pig.setMixByName("GoldPig", "GoldPig_Idle", .3);
            this.pig.play("GoldPig_Idle", false);

            this.addTween([this.description, this.title], 500, { alpha: 1 });
            this.addTween(this.playButton, 500, { alpha: 1 });
            this.addTween(this.playButton, 1000, { scaleX: 1, scaleY: 1 }, "Back");
            this.addTween(this.playButton, 500, { scaleX: 1.2, scaleY: 1.2, delay: 300, repeat: -1, yoyo: true }, "Back");
        });

        this.pig.shadowSpine.setDepth(-1);
        this.pig.spine.setDepth(0);
        
        this.pigFront = this.addImage(this.pig.x, this.pig.y, "PigFront");
        this.pigFront.setDepth(1);
        this.events.on('shutdown', ()=>{
            this.stopSounds();
        });

        this.counterBG = this.addImage(130, 170, "AnsrScrn").setAlpha(0).setDepth(3).setScale(0);
        this.counterText = this.addText(130, 167, 24, 0x83BD05, gameData.fonts.comfortaa_bold, "$0.00").setDepth(3).setAlpha(0).setScale(0);

        // this.startGame();
    }

    gameOver()
    {
        while(this.coins.length > 0)
        {
            let coin = this.coins.pop();
            coin.destroy();
        }
        this.dropCoinEvent.destroy();
        this.isStarted = false;
        this.pig.play("GoldPig_Idle");
        this.killTween([this.pig.spine, this.pigShadow]);
        this.addTween(this.banner, 400, {y: -65}, Phaser.Math.Easing.Sine.Out, ()=>{this.banner.destroy();});
        this.addTween(this.ground, 400, {y: 800}, Phaser.Math.Easing.Sine.Out, ()=>{this.ground.destroy();});
        this.addTween(this.pigShadow, 400, {alpha: 0}, Phaser.Math.Easing.Sine.Out);
        this.addTween([this.counterBG, this.counterText], 400, {alpha: 0, scaleX: 0, scaleY: 0}, Phaser.Math.Easing.Sine.Out);
        this.addTween(this.bonusTimer, 800, {scaleX: 1.4, scaleY: 1.4, x: this.mid.x, y: this.mid.y}, "Back", ()=>{
            this.addTween(this.bonusTimer, 400, {scaleX: 0, scaleY: 0}, Phaser.Math.Easing.Sine.Out, ()=>{
                this.bonusTimer.destroy();
                this.showEndScreen();
            });
        });
    }

    showEndScreen()
    {
        let scaleDiff = 1.5/this.pig.spine.scaleY;
        
        this.addTween(this.pig.spine, 800, {scaleX: 1.5, scaleY: 1.5, x: this.mid.x - 20, y: 650}, "Back", ()=>{
            this.menu = new GameMenu(this, true);
            this.playSound("bonus_coins_spill");
            for(let i = 0; i < this.coinsCollected.length; i++)
            {
                this.addDelay(i * 150, ()=>{
                    let coin = this.addSprite(this.mid.x, this.mid.y - 150, this.coinsCollected[i]+"Anim").setScale(gameData.coinData[this.coinsCollected[i]].scale).setDepth(0);
                    coin.anims.stop();

                    this.addDelay(275, ()=>{coin.anims.play();});
                    this.addDelay(450, ()=>{
                        coin.setDepth(4);
                    });

                    let xOffset = Phaser.Math.Between(-180, 180);
                    let parabolla = new Phaser.Curves.Spline([
                        coin.x, coin.y, 
                        coin.x + xOffset, coin.y - 150,
                        coin.x + (xOffset * 2), 950
                    ]);
                    this.addPathTween(coin, parabolla, 1500, {}, Phaser.Math.Easing.Linear.Linear, ()=>{coin.destroy();});
                });
                
            }

            let titleText = this.addImage(this.mid.x, this.mid.y - 65, "YouDidIt").setAlpha(0).setDepth(2);
            let description = this.addText(this.mid.x + 20, this.mid.y, 38, 0xa86f08, gameData.fonts.comfortaa_bold, "You collected: $"+this.moneyCollected.toFixed(2), null, true);
            description.setDepth(2).setAlpha(0);

            let playButton = this.addButton(this.mid.x, 675, "Title_PlyBtn", ()=>{
                this.scene.start("Intro");
            }).setAlpha(0).setScale(2);
            this.addTween(playButton, 500, { alpha: 1 });
            this.addTween(playButton, 1000, { scaleX: 1, scaleY: 1 }, "Back");
            this.addTween(playButton, 500, { scaleX: 1.2, scaleY: 1.2, delay: 300, repeat: -1, yoyo: true }, "Back");

            this.addTween([titleText, description], 400, {alpha: 1}, Phaser.Math.Easing.Sine.Out);
        });
    }

    startGame()
    {
        this.killTween([this.playButton, this.description, this.title, this.pig.spine]);
        this.addTween(this.playButton, 200, {alpha: 0, scaleX: 0, scaleY: 0});
        this.addTween([this.description, this.title], 200, {alpha: 0});

        this.ground = this.addRect(0, 671, this.size.width, 97, 0x1E6606).setDepth(-1);
        this.pig.play("GoldPig_Idle", false);
        this.pigShadow = this.addEllipse(this.pig.spine.x, 740, 200, 50).setDepth(-1);
        this.pigShadow.alpha = 0;
        this.pigShadow.setScale(2);
        this.addTween(this.pig.spine, 600, {scaleX: .45, scaleY: .45, y: 400}, "Back", ()=>{
            this.pig.shadowSpine.destroy();
            this.pig.shadowSpine = null;
            this.addTween(this.pigShadow, 1200, {scaleX: 1, scaleY: 1, alpha: .4}, "Bounce");
            this.addTween(this.pig.spine, 1200, {scaleX: .45, scaleY: .45, y: 720}, "Bounce", ()=>{
                this.gameStarted();
            });
        });
        
        this.addTween(this.pig.shadowOffset, 1200, {x: 0, y: 0}, "Back");
    }

    gameStarted()
    {
        this.isStarted = true;
        this.bonusTimer.startTimer(30, ()=>{this.gameOver();});
        this.dropCoinEvent = this.addRepeatingEvent(this.coinSpawnFrequency, ()=>{
            this.dropCoin();
        });
        this.addTween(this.banner, 300, {y: 55});
        this.addTween(this.bonusTimer, 800, {scaleX: 1, scaleY: 1}, "Back");
        this.addTween([this.counterBG, this.counterText], 800, {scaleX: 1, scaleY: 1, alpha: 1}, "Back");
        this.dropCoin();
    }

    dropCoin()
    {
        let randNum = Math.random();
        let coinName = "";

        if(randNum < this.coinChances.quarter) coinName = "quarter";
        else if(randNum < this.coinChances.dime) coinName = "dime";
        else if(randNum < this.coinChances.nickel) coinName = "nickel";
        else coinName = "penny";

        let coinData = gameData.coinData[coinName];
        let coin = this.addSprite(Phaser.Math.Between(100, this.size.width - 100), - 200, coinName+"Anim");

        coin.skin = coinName;
        coin.value = coinData.value;
        coin.setScale(coinData.scale);
        coin.setDepth(2);
        coin.setFrameIndex(Phaser.Math.Between(0, 30)); 

        this.coins.push(coin);
    }

    get openeingPos()
    {
        return {x: this.pigFront.x + (-10 * this.pig.spine.scaleX), y: this.pigFront.y - (105 * this.pig.spine.scaleY)};
    }

    update(time, deltaTime)
    {
        let bone = this.pig.spine.skeleton.bones[0];
        this.pigFront.setScale(this.pig.spine.scaleX, this.pig.spine.scaleY);
        this.pigFront.setPosition(this.pig.spine.x - (bone.x * this.pig.spine.scaleX) + (61.3 * this.pig.spine.scaleX), this.pig.spine.y - (bone.y * this.pig.spine.scaleY));

        if(!this.isStarted) return;

        this.movePig(deltaTime);

        this.coins.forEach((coin)=>{
            coin.y += this.coinFallSpeed * deltaTime;
            if(coin.y > 700) 
            {
                this.coins.splice(this.coins.indexOf(coin), 1);
                let xOffset = (coin.x - this.mid.x) * .2;
                let parabolla = new Phaser.Curves.Spline([
                    coin.x, coin.y, 
                    coin.x + xOffset, coin.y - 50,
                    coin.x + (xOffset * 2), 800
                ]);
                coin.play("flipForward", true, null, 10);
                this.addTween(coin, 500, {scaleX: coin.scaleX * .6, scaleY: coin.scaleX * .6});
                this.addPathTween(coin, parabolla, 500, {}, Phaser.Math.Easing.Sine.Out, ()=>{coin.destroy();});
            }

            let coinDistanceX = this.openeingPos.x - coin.x;
            let coinDistanceY = this.openeingPos.y - coin.y;

            if(Math.abs(coinDistanceX) < this.pigCatchThreshold_Width && coinDistanceY > -100 && coinDistanceY < this.pigCatchThreshold_Height * (1-(Math.abs(coinDistanceX)/this.pigCatchThreshold_Width)))
            {
                this.catchCoin(coin, coinDistanceX);
            }   
        });
    }

    movePig(deltaTime)
    {
        if(this.pig.isCatchingCoin) return;

        let pigSpine = this.pig.spine;
        let mousePigDiff = this.input.x - pigSpine.x;
        let direction = mousePigDiff > 0 ? 1 : -1;
        let velocity = (direction * this.pigMoveSpeed) * deltaTime;
        
        if((this.isWalking && Math.abs(mousePigDiff) > 20) || (!this.isWalking && Math.abs(mousePigDiff) > 80))
        {
            this.isWalking = true;
            if(!this.isJumping)
            {
                if(this.pig.currentanimation != "GoldPig") this.pig.play("GoldPig", true, null, Math.abs(velocity) * .3);
            }
            pigSpine.scaleX = .45 * direction;
            pigSpine.x += velocity;
        }
        else
        {
            this.isWalking = false;
            if(!this.isJumping) if(this.pig.currentanimation != "GoldPig_Idle") this.pig.play("GoldPig_Idle", true);
        }

        this.pigShadow.x = pigSpine.x;
    }

    catchCoin(coin)
    {
        this.coins.splice(this.coins.indexOf(coin), 1);

        coin.play("flipForward", false, null, 30);

        this.moneyCollected += coin.value;
        this.counterText.text = "$" + this.moneyCollected.toFixed(2);

        let coinTween = this.addTween(coin, 250, {y: this.openeingPos.y - 50, x: this.openeingPos.x, onUpdate: ()=>{
            coinTween.updateTo('x', this.openeingPos.x);
            coinTween.updateTo('y', this.openeingPos.y - 50);
        }}, Phaser.Math.Easing.Sine.Out, ()=>{
            this.playSound("bonus_collect_coins");
            coin.setDepth(0);
            coinTween = this.addTween(coin, 200, {y: this.openeingPos.y + 100, scaleX: coin.scaleX * .6, scaleY: coin.scaleX * .6,  onUpdate: ()=>{
                coin.x = this.openeingPos.x;
                coinTween.updateTo('y', this.openeingPos.y + 50);
            }}, Phaser.Math.Easing.Sine.Out, ()=>{
                coin.destroy();
            });
        });

        this.coinsCollected.push(coin.skin);
        this.jumpPig();
    }

    jumpPig()
    {
        if(this.isJumping) return;
        this.isJumping = true;

        let pigSp = this.pig.spine;
        this.pig.play("GoldPig_Jump", true);

        this.killTween([pigSp, this.pigShadow]);
        this.addTween(pigSp, 300, { y: 600 }, Phaser.Math.Easing.Linear.Linear, ()=>{
            
            this.pig.play("GoldPig_Idle", true);
            this.addTween(pigSp, 300, {y: 720}, Phaser.Math.Easing.Sine.In, ()=>{
                this.isJumping = false;
            });
        });

        this.addTween(this.pigShadow, 300, {alpha: .1, scaleX: .3, scaleY: .3}, Phaser.Math.Easing.Linear.Linear, ()=>{
            this.addTween(this.pigShadow, 300, {alpha: .4, scaleX: 1, scaleY: 1}, Phaser.Math.Easing.Sine.In);
        });
    }
}